var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-clients"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clients",
    clipPath: "url(#clip-clients)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(-44.107 -713.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(44.108 715.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M67.785,736.224a9.238,9.238,0,0,1,1.7-1.406,14.527,14.527,0,0,0-1.318-1.545,14.05,14.05,0,0,0-5.356-3.359,8.15,8.15,0,1,0-9.223,0,14.115,14.115,0,0,0-9.485,13.327h2.2a11.879,11.879,0,0,1,21.474-7.018ZM58.2,729.145a5.946,5.946,0,1,1,5.948-5.946A5.954,5.954,0,0,1,58.2,729.145Z",
    transform: "translate(-43.108 -715.05)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 8.662,
    cy: 8.662,
    r: 8.662,
    transform: "translate(21.144 18.324)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(28.645 22.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M61.97,728.791l.643-1.24h-2.7l.641,1.24Z",
    transform: "translate(-59.6 -727.55)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M62.071,728.424h-1.34l-.984,5.558a.435.435,0,0,0,.092.352l1.224,1.492a.437.437,0,0,0,.339.159.432.432,0,0,0,.337-.161l1.224-1.493a.425.425,0,0,0,.092-.348Z",
    transform: "translate(-59.74 -726.822)",
    fill: "#5c6d7e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.13d935c2b2559b700b91daf056930cfc.svg";
export { ForwardRef as ReactComponent };